FORMAT_LOCALE_LONG_MDY_FR